'use strict';

var NewCalibrationAnalysisDirective = function NewCalibrationAnalysisDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calibration-analysis.html'),
    controller: 'NewCalibrationAnalysisController',
    scope: {
      newCalibrationAnalysis: '=',
      marketList: '=',
      submitCallback: '='
    },
    link: function link($scope, element) {
      element.on('hidden.bs.modal', function () {
        if ($scope.submitted) {
          $timeout(function () {
            $scope.submitCallback();
            $scope.submitted = false;
          }, 0);
        }
      });
      var modal_element = element.find('#submit-for-calibration-analysis-modal');
      $scope.openSubmitModal = function () {
        modal_element.modal('show');
      };
      $scope.closeSubmitModal = function () {
        modal_element.modal('hide');
      };
    }
  };
};
NewCalibrationAnalysisDirective.$inject = ['$timeout'];
module.exports = NewCalibrationAnalysisDirective;